import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ProductOverviewRequest } from '../product-overview/product-overview-request.model';

@Injectable({
  providedIn: 'root',
})
export class MainTabsService {

  constructor(private http: HttpClient) {
  }

  openFinancingView(parentCustomerId: string, bankCode: string) {
    const request = this.createFinancieringsbeeldRequest(environment.financieringsbeeldURL, parentCustomerId);
    window.open(request, '_blank');
  }

  getParameters() {
    const requestBody = this.createRequestBody();
    const headers = this.createHeaders();

    return this.http.post<any>(environment.civServicesBaseURL + 'parameters', requestBody, { headers })
      .pipe(
        map((resp) => {
          const decodedParentCustomerId = atob(resp.ptID);
          resp.parentCustomerId = decodedParentCustomerId;
          return resp;
        })
      );
  }

  public createFinancieringsbeeldRequest(url: string, parentCustomerId: string) {
    let finalUrl = url + parentCustomerId;
    return finalUrl;
  }

  private createRequestBody(): string | undefined {
    if (!ProductOverviewRequest) {
      return undefined;
    }
    const requestBodyContent = {
      parametersToken: ProductOverviewRequest.parametersToken,
    };
    return JSON.stringify(requestBodyContent);
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();

    const token = ProductOverviewRequest.token || '';
    const graphToken = ProductOverviewRequest.graphToken || '';

    headers = headers.append('Authorization', token);
    headers = headers.append('MFA-Authorization', token);
    headers = headers.append('Graph-Authorization', graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

  getChronosURLAPICall() {
    const requestBody = this.createRequestBody();
    const headers = this.createHeaders();
    return this.http.post(environment.civServicesBaseURL + 'chronos', requestBody, { headers });
  }
}
